import { IHouseDivision, IName } from '..';
import { NursingOverviewType } from '../enums';

export interface INursingOverviewData {
  date?: Date;
  type?: NursingOverviewType;
  information?: string[];
}

export interface ResidentWithNursingOverview {
  id: string;
  livingArea: Pick<IHouseDivision, 'name'> | null;
  room: Pick<IHouseDivision, 'name'> | null;
  name: IName;
  nursingOverview: INursingOverview;
}

export interface INursingOverview {
  carePlans?: INursingOverviewData[];
  wounds?: INursingOverviewData[];
  falls?: INursingOverviewData[];
  pains?: INursingOverviewData[];
  medications?: INursingOverviewData[];
  nursingReports?: INursingOverviewData[];
  visitSheets?: INursingOverviewData[];
  nutritionProtocols?: INursingOverviewData[];
  vitalSigns?: INursingOverviewData[];
  vitalSignsHistory?: INursingOverviewData[];
  socialCareReports?: INursingOverviewData[];
}

export enum NursingOverviewMedicationType {
  ADDED = 'ADDED',
  ENDED = 'ENDED',
  ALL = 'ALL',
}

export enum NursingOverviewVisitSheetType {
  OPEN = 'OPEN',
  ANSWERED = 'ANSWERED',
  ALL = 'ALL',
}
